import React from "react";
// material-ui
import { useTheme } from "@mui/material/styles";
import { Box, Drawer, useMediaQuery } from "@mui/material";

// third-party
import { BrowserView, MobileView } from "react-device-detect";

// project imports
import MenuList from "./MenuList";
import LogoSection from "../Header/LogoSection";
import { HEADER_HEIGHT, SIDEBAR_WIDTH } from "../../theme";

// ==============================|| SIDEBAR DRAWER ||============================== //

/**
 * The left navigation.
 *
 * Fixed at `SIDEBAR_WIDTH` px rather than the `15vw` it used to be: a menu
 * whose labels wrap on a 13" laptop and float on a 27" monitor is a menu that
 * was never measured. The one visual difference from the page is a faintly
 * tinted background and a hairline on its right edge.
 */
const Sidebar = ({ drawerOpen, drawerToggle }) => {
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up("md"));

  const width = SIDEBAR_WIDTH;

  // Below `md` the drawer is a temporary overlay, so its slot in the layout row
  // must take no space - a 260px slot there pushed every page off the right
  // edge of a narrow window, with an empty band where the menu is not.
  return (
    <Box
      component="nav"
      sx={{ width: matchUpMd ? width : 0, flexShrink: 0 }}
      aria-label="Main navigation"
    >
      <Drawer
        variant={matchUpMd ? "persistent" : "temporary"}
        anchor="left"
        open={!!drawerOpen}
        onClose={drawerToggle}
        sx={{
          "& .MuiDrawer-paper": {
            width,
            background: theme.palette.background.sidebar,
            color: theme.palette.text.primary,
            borderRight: `1px solid ${theme.palette.divider}`,
            paddingBottom: "24px",
            [theme.breakpoints.up("md")]: {
              top: `${HEADER_HEIGHT}px`,
              height: `calc(100% - ${HEADER_HEIGHT}px)`,
            },
          },
        }}
        ModalProps={{ keepMounted: true }}
        color="inherit"
      >
        <BrowserView>
          {/* Native scrolling rather than react-perfect-scrollbar: its rail
              drew a permanent grey bar down the sidebar's inner edge, beside
              the drawer's own border. The themed scrollbar only shows a thumb,
              and only while there is something to scroll. */}
          <Box sx={{ width: "100%", p: "8px 12px 24px" }}>
            <MenuList />
          </Box>
        </BrowserView>

        <MobileView>
          <Box sx={{ px: 2.5, py: 2 }}>
            <LogoSection />
          </Box>
          <Box sx={{ px: 1.5 }}>
            <MenuList />
          </Box>
        </MobileView>
      </Drawer>
    </Box>
  );
};

export default Sidebar;
